(() => {
  if (window.__sliderWrapperBound) return;
  window.__sliderWrapperBound = true;

  const SELECTOR = "[data-slider-wrapper]";

  const prefersReducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const syncControls = (emblaApi, controls) => {
    if (!controls) return;
    controls.hidden = emblaApi.scrollSnapList().length <= 1;
  };

  const initWrapper = (root) => {
    if (!root || !window.ThemeCarousel) return;

    const viewport = root.querySelector(".carousel__viewport");
    if (!viewport) return;

    const prevBtn = root.querySelector("[data-slider-wrapper-prev]");
    const nextBtn = root.querySelector("[data-slider-wrapper-next]");
    const progressEl = root.querySelector("[data-slider-wrapper-progress]");
    const controls = root.querySelector("[data-slider-wrapper-controls]");
    const parsedStartIndex = Number.parseInt(root.dataset.startIndex, 10);
    const startIndex =
      Number.isInteger(parsedStartIndex) && parsedStartIndex >= 0
        ? parsedStartIndex
        : 0;

    window.ThemeCarousel.create(
      viewport,
      {
        align: "start",
        containScroll: "trimSnaps",
        startIndex,
        duration: prefersReducedMotion() ? 0 : 10,
      },
      [],
      {
        prev: prevBtn,
        next: nextBtn,
        progress: progressEl,
        onInit: (emblaApi) => {
          root.classList.add("is-initialized");
          syncControls(emblaApi, controls);
          emblaApi.on("reInit", () => syncControls(emblaApi, controls));
        },
      },
    );
  };

  const initAll = (scope = document) => {
    if (scope?.matches?.(SELECTOR)) {
      initWrapper(scope);
      return;
    }

    scope.querySelectorAll?.(SELECTOR)?.forEach(initWrapper);
  };

  const destroyIn = (scope) => {
    const roots = scope?.matches?.(SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(SELECTOR) || []);

    roots.forEach((root) => {
      const viewport = root.querySelector(".carousel__viewport");
      if (viewport) window.ThemeCarousel?.destroy(viewport);
      root.classList.remove("is-initialized");
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(), {
      once: true,
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroyIn(event.target);
  });

  window.SliderWrapper = {
    init: initAll,
    destroy: destroyIn,
  };
})();
